import React from 'react'
import { AudienceStatusIndicatorProps, audienceStatusStyles } from './'

export function AudienceStatusIndicator({ status, className }: AudienceStatusIndicatorProps) {
  // Statuses reach this from Facebook as well as from us, so an unmapped one
  // shows its own name rather than crashing on a missing entry.
  const style = audienceStatusStyles[status] ?? {
    text: status,
    toneClass: 'bg-mm-neutral-2-100 text-mm-neutral-2-700',
  }

  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${
        style.toneClass
      } ${className ?? ''}`}
    >
      {style.text}
    </span>
  )
}
